export const version = "7.3.9";
export const major = Number("7");
export const minor = Number("3");
export const patch = Number("9");
export const prerelease = undefined;
export default version;